<template lang="html">
  <div>
    <div
      class="row et_row_complete text-center p-0 py-4 cpl-event col-12 col-md-6 m-auto"
    >
      <!-- event -->
      <div class="col-6">
        <div
          :title="$store.state.selected_teampage.page.Event.EventName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="
              $gfImagePlugin.getImageWithResolution(
                $store.state.selected_teampage.page.Event.EventImagePath,
                1000
              )
            "
            class="card-img-top img-fluid"
            alt=""
          />
        </div>
        <p>
          {{ $store.state.selected_teampage.page.Event.EventName }}
        </p>
      </div>

      <!-- team name -->
      <div class="col-6">
        <div
          :title="$store.state.selected_teampage.page.PageTitle"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="$store.state.selected_teampage.page.ImagePath"
            class="card-img-top img-fluid"
            alt=""
          />
        </div>
        <p>
          {{ $store.state.selected_teampage.page.PageTitle }}
        </p>
      </div>
    </div>
    <div class="col-md-6 m-auto">
      <div class="row justify-content-md-center gf-connect-fb">
        <template v-if="$store.state.userLogon">
          <Logged
            @submitFormComplete="$_createFundraisingPageMixin_submitComplete"
          />
        </template>
        <template v-else>
          <Login
            v-if="$store.state.loginStatus == 'login'"
            @StatusCheckLogin="StatusCheckLogin"
          />
          <ForgotPassword
            v-else-if="$store.state.loginStatus == 'forgot'"
            @StatusCheckLogin="StatusCheckLogin"
          />
          <Register v-else @StatusCheckLogin="StatusCheckLogin" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Login from "../login/Login.vue";
import Logged from "../login/Logged.vue";
import ForgotPassword from "../inc/forgetpassword.vue";
import Register from "../login/Register.vue";
import CreateFundraisingPageMixin from "../inc/CreateFundraisingPageMixin.vue";

export default {
  components: {
    Login,
    Logged,
    ForgotPassword,
    Register
  },

  mixins: [CreateFundraisingPageMixin],

  async mounted() {
    (this.pageType = "S"),
      (this.teamId = this.$store.state.selected_teampage.page.Id);
    this.charityId = this.$store.state.selected_teampage.page.Beneficiary.BeneficiaryAccountId;
    this.eventCampaignId = this.$store.state.selected_teampage.page.Event.EventCampaignId;

    try {
      await this.$_createFundraisingPageMixin_loadVueAnalytics();
    } catch (e) {
      console.log("Failed to load google Analytics.");
    }
  },

  methods: {
    StatusCheckLogin(value) {
      this.$store.commit("setLoginStatus", value);
    }
  }
};
</script>
<style scoped>
.card-img-top.img-fluid {
  width: 100%;
  height: 8vw;
  object-fit: contain;
}
</style>
